import * as z from "zod";

const AvailableBinSchema = z.object({
  storageLocationId: z.string(),
  binName: z.string(),
  availableQuantity: z.number(),
  inventoryItemId: z.string().nullish(),
  lotNumber: z.string().nullish(),
  expirationDate: z.string().nullish(),
});

const ProductBinsSchema = z.object({
  productId: z.string(),
  productName: z.string(),
  imageUrl: z.string().nullish(),
  requiredQuantity: z.number(),
  bins: z.array(AvailableBinSchema),
});

export const getAvailableBinsForFulfillmentGroups = {
  name: "getAvailableBinsForFulfillmentGroups" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({
    lineItems: z.array(ProductBinsSchema),
    /**
     * The subset of the requested fulfillment groups that genuinely need a
     * manual bin selection — i.e. groups still needing bins that have at
     * least one product shown in `lineItems`. Pass this (not the full
     * requested set) to recordDirectBinPicks so already-sourced and
     * fully-onboarding groups aren't given spurious transfers.
     */
    manualPickFulfillmentGroupIds: z.array(z.string()),
    fulfillmentGroupIdsNeedingBins: z.array(z.string()).optional(),
  }),
};
